<template>
  <div
    class="textarea-component"
    :class="{
      'resize-textarea': shouldResize,
    }">
    <label :for="'textarea' + id"
      >{{ placeHolder }} <template v-if="errorMessage">- {{ errorMessage }}</template></label
    >
    <textarea
      placeholder=" "
      :id="'textarea' + id"
      v-model="val"
      @input="resize()"
      ref="textAreaComponent"
      :readonly="readOnly" />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
  placeHolder?: string;
  errorMessage?: string;
  modelValue?: string | string[];
  shouldResize?: boolean;
  readOnly?: boolean;
}>();
const id = Math.random().toString(36).slice(2);
const textAreaComponent = ref<HTMLElement | null>(null);

const val = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val);
  },
});

onMounted(() => {
  resize();
});

function resize(): void {
  if (props.shouldResize) {
    if (textAreaComponent.value) {
      textAreaComponent.value.style.height = '102px';
      textAreaComponent.value.style.height = textAreaComponent.value.scrollHeight + 2 + 'px';
      if (textAreaComponent.value.scrollHeight > textAreaComponent.value.offsetHeight) {
        textAreaComponent.value.style.height = textAreaComponent.value.scrollHeight + 2 + 'px';
      }
      if (props.modelValue === '') {
        textAreaComponent.value.style.height = '102px';
      }
    }
  }
}
</script>
